export const config = {
    api_base: 'https://rules.diningtek.com/api/v1',
    api_root : 'https://rules.diningtek.com',
    site_key : '6LdhdNgUAAAAABk8kk7tJYXOj-6sCzUZ1FXpus9l',
    secret_key : '6LdhdNgUAAAAAG_8exdGndAHVLt-nJZN7U8kz_yS'
};
